jQuery(document).ready(function ($) {

    // SVGInject
    SVGInject(document.querySelectorAll("img.injectable"));

    // scrollTO
    $('a[href^="#"]').on('click', function (event) {
        var topOuterHei = $('header').outerHeight();
        var target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top - topOuterHei
            }, 1000);
        }
    });

    if (window.location.hash) {
        $('html,body').animate({
            scrollTop: $(window.location.hash).offset().top
        }, 10);
    }

    // AOS
    AOS.init({
        duration: 450,
        once: true
    });

    // validar


    //scroll to error
    const formMessage = $('.module-sing-up__form-message--scroll');
    if (formMessage.length > 0) {
        $('html, body').animate({ scrollTop: formMessage.offset().top - (($(window).height() - formMessage.height()) / 2) }, 1000);
    }

    const newsetterForm = $('.module-contact__form');
    if (newsetterForm.length > 0) {
        $.validate({
            form: '.module-contact__form',
            lang: 'pl',
            errorMessagePosition: $('.module-contact__form-validation'),
            validateOnBlur: false,
            scrollToTopOnError: false,
            onSuccess: function ($form) {
                var response = grecaptcha.getResponse();
                if (response.length == 0) {
                    return false;
                }
            },
        });
    }

    $.formUtils.addValidator({
        name: 'conference_selectbox',
        validatorFunction: function (value, $el, config, language, $form) {

            let validate = true;
            let index = $('input.select-box__hidden-input').index($el);

            if (value == 0) {
                validate = false
                if (index % 2 == 0) {
                    if ($el.closest('.select-box').next().next().find('.select-box__hidden-input').val() != 0) validate = true;
                } else {
                    if ($el.closest('.select-box').prev().prev().find('.select-box__hidden-input').val() != 0) validate = true;
                }
            }

            return validate;
        },
        errorMessage: 'Wybierz udział w konferencji lub warsztacie.',
        errorMessageKey: 'requiredFields'
    });

    const trainingForm = $('#trainingForm');
    if (trainingForm.length > 0) {
        $.validate({
            form: '#trainingForm',
            lang: 'pl',
            modules: 'poland, logic',
            errorMessagePosition: $('.module-sing-up__form-validation'),
            validateOnBlur: false,
            scrollToTopOnError: false,
            validateHiddenInputs: true,
            onError: function ($form) {
                $('.module-sing-up__form-message--success').hide();
            },
        });
    }


    //scroll to error
    const newsetterFormMessage = $('.module-contact__form-message');
    if (newsetterFormMessage.length > 0) {
        $('html, body').animate({ scrollTop: newsetterFormMessage.offset().top - (($(window).height() - newsetterFormMessage.height()) / 2) }, 1000);
    }

    // datepicker
    const datePicker = $('#datePickerScript');
    if (datePicker.length > 0) {
        var startDate = $('#startDate');
        var endDate = $('#endDate');

        $('[data-toggle="datepicker"]').datepicker({
            language: 'pl-PL',
            format: 'mm/yyyy',
            autoHide: true,
            startDate: $('input[name="start_date"]').val(),
            endDate: $('input[name="end_date"]').val(),
        });
        endDate.datepicker({
            startDate: startDate.datepicker('getDate'),
        });

        startDate.on('change', function () {
            endDate.datepicker('setStartDate', startDate.datepicker('getDate'));
        });
    };


    var setHeight = function () {
        var top = $('header').outerHeight();
        $('main').css({ 'padding-top': top + 'px' });
    }

    setHeight();

    $(window).resize(function () {
        setHeight();
    });

    // mobile nav
    var mobileBtn = $('.mobile-btn');
    var mobileNav = $('.mobile-nav');
    var header = $('.header');

    mobileBtn.on('click', function (e) {
        var active = ($(this).hasClass('active')) ? 1 : 0;

        if (active) {
            mobileBtn.removeClass('active');
            mobileNav.removeClass('active');
            header.removeClass('active');
            $('body,html').removeClass('body-overflow');
        } else {
            mobileBtn.addClass('active');
            mobileNav.addClass('active');
            header.addClass('active');
            $('body,html').addClass('body-overflow');
        }

        return false;
    });

    // header - add class on scroll
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            header.addClass('header--fixed');
        } else {
            header.removeClass('header--fixed');
        }
    });

    // resize (remove mobile & fixed)
    $(window).on('resize', function () {
        var win = $(this);
        if (win.width() >= 992) {
            mobileBtn.removeClass('active');
            mobileNav.removeClass('active');
            header.removeClass('active');
        }
    });

    // swiper - homepage training
    const homeTraining = $('#homeTraining');
    if (homeTraining.length > 0) {
        let swiper = new Swiper('#homeTraining', {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
            allowTouchMove: false,
            threshold: 10,
            preventClicks: false,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: {
                el: '#homeTraining .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                767: {
                    autoHeight: true,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    allowTouchMove: true,
                },
                991: {
                    autoHeight: false,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
        });
    };

    //  module-join - show offer after click
    const offer = $('.joinOffer');
    offer.on('click', function (event) {
        event.preventDefault();
        /* Act on the event */
        const box = $(this);
        const active = box.hasClass('active');

        if (active) {
            box.removeClass('active');
        } else {
            offer.removeClass('active');
            box.addClass('active');
        }
    });

    //  faq
    const question = $('.module-faq__single');
    question.on('click', function (event) {
        event.preventDefault();
        /* Act on the event */
        const singleQuestion = $(this);
        const active = singleQuestion.hasClass('active');

        if (active) {
            singleQuestion.removeClass('active');
        } else {
            question.removeClass('active');
            singleQuestion.addClass('active');
        }
    });

    // team - popup
    const popupsWrapper = $('#teamPopupWrapper');
    function showServicePopup(el) {
        el.show();
        popupsWrapper.addClass('active');
    }
    function hideServicePopup(el) {
        el.hide();
        popupsWrapper.removeClass('active');
    }
    popupsWrapper.on('click', function () {
        $(this).removeClass('active');
        $(this).find('.module-team__popup').hide();
    })
    $('.module-team__popup').on('click', function (e) {
        e.stopPropagation();
    });
    $('.module-team__box').on('click', function () {
        const popupId = $(this).data('id');
        const selector = '.module-team__popup[data-id="' + popupId + '"]';
        const popup = $(selector);

        if (popup.length > 0) {
            showServicePopup(popup);
        }
        return false;
    });
    $('.module-team__popup-close').on('click', function () {
        const popup = $(this).parent();
        hideServicePopup(popup);
        return false;
    });

    // show clients info on click - homepage
    const clientLogo = $('.module-partners__logo-box');
    const clientInfo = $('.module-partners__container');

    if (clientLogo.length > 0) {
        clientLogo.eq(0).addClass('selected');
    }

    function showContent(el) {
        clientInfo.stop().hide();
        clientInfo.removeClass('active');
        el.fadeIn(200);
    }

    clientLogo.on('click', function () {
        const contentId = $(this).data('id');
        const selector = '.module-partners__container[data-id="' + contentId + '"]';
        const logoSelector = '.module-partners__logo-box[data-id="' + contentId + '"]';
        const content = $(selector);
        const logoContent = $(logoSelector);

        if (content.length > 0) {
            showContent(content);
            clientLogo.removeClass('selected');
            logoContent.addClass('selected');

            const swiperSelector = $(content).find('.swiper-container');
            if (swiperSelector.length > 0) {

                swiperSelector.each(function (index, element) {

                    let swiper = new Swiper(element, {
                        allowTouchMove: false,
                        slidesPerView: 1,
                        threshold: 20,
                        pagination: {
                            el: '.module-partners .swiper-pagination',
                            type: 'bullets',
                            clickable: true,
                        },
                        breakpoints: {
                            991: {
                                allowTouchMove: true,
                            }
                        }
                    });
                });

            }
        }
        return false;
    });

    const tableSwiper = $('.table-swiper');
    if (tableSwiper.length > 0) {
        const swiper = new Swiper('.table-swiper', {
            slidesPerView: 'auto',
            direction: 'horizontal',
            freeMode: true,
            nested: true,
            mousewheel: true,
            allowTouchMove: false,
            breakpoints: {
                576: {
                    allowTouchMove: true,
                }
            },
        });
    }

    // select box
    $('body').on('click', '.select-box', function (event) {
        var isActive = $(this).hasClass('select-box--active');
        var field = $(this).find('.select-box__field');

        // close active select box (if exist)
        $('.select-box').each(function () {
            $(this).removeClass('select-box--active');
            $(this).find('.select-box__field').css('z-index', '0');
        });

        if (isActive) {
            $(this).removeClass('select-box--active');
            field.css('z-index', '0');
            if ($(this).hasClass('select-box--redirect') && !$(event.target).closest('li').is('.current') && !$(event.target).closest('span').is('.select-box__field')) {
                $(this).closest('form').addClass('module-sing-up__form--blocked');
                return true;
            } else {
                return false;
            }

        } else {
            $(this).addClass('select-box--active');
            field.css('z-index', '2');
            return false;
        }

    });

    // select box - click on body
    $("body").on('click', function (e) {
        if (e.target.className !== "select-box__list") {
            $(".select-box").removeClass('select-box--active');
        }
    });

    // select box - change values
    $('body').on('click', '.select-box li', function (event) {
        var val = $(this).data('value');
        const anchor = $(this).clone();
        var text = $(this).text();
        var list = $(this).parent();
        var selectBox = list.parent();
        var span = selectBox.find('.select-box__field');
        var input = selectBox.find('input[type="hidden"]');
        var isActive = ($(this).hasClass('selected')) ? 1 : 0;

        // clear selects
        list.find('li').removeClass('selected');
        $(this).addClass('selected');
        const newText = anchor.html();

        // set data
        const newVal = val;

        // update
        if (input.length > 0) {
            input.val(newVal);
        }

        span.html(newText);

    });

    //select box - cilck firs value on load
    function selecboxClick(selector) {
        if (selector) {
            selector.find('.select-box__list li.active').first().click();
            $('body').click();
        } else {
            $('.select-box').each(function () {
                $(this).find('.select-box__list li.active').first().click();
                $('body').click();
            });
        }
    };
    selecboxClick();

    // add another person
    const formPersonClear = $('.module-sing-up__form-persons').html();
    $('.module-sing-up').on('click', '.module-sing-up__form-add', function (event) {
        var max = parseInt($(this).attr('data-max'));
        if (max > 0) {
            $('.module-sing-up__form-persons').append(formPersonClear);
            $(this).attr('data-max', max - 1);
            if (max == 1) {
                $(this).hide();
            }
        }

        event.preventDefault();
    });

    // remove person
    $('.module-sing-up__form-person').find('.module-sing-up__form-remove').hide();
    $('body').on('click', '.module-sing-up__form-remove', function (event) {
        $(this).closest('.module-sing-up__form-person').hide().remove();

        var max = parseInt($(this).attr('data-max'));
        $(this).attr('data-max', max + 1);

        event.preventDefault();
    });

    // invoice other data
    $('input[name=invoice]').change(function () {
        if ($(this).is(':checked')) {
            $('.module-sing-up__form-invoice').show();
        } else {
            $('.module-sing-up__form-invoice').hide();
        }
    });

    // invoice disable
    $('input[name=private]').change(function () {
        if ($(this).is(':checked')) {
            $('.module-sing-up__form-input--private').hide();
            $(this).parent().find('input[name="private_hidden"]').val('true');
            $('input[name=invoice]').prop("checked", false).parent().addClass('disabled');
            $('.module-sing-up__form-invoice').hide();
        } else {
            $('.module-sing-up__form-input--private').show();
            $(this).parent().find('input[name="private_hidden"]').val('false');
            $('input[name=invoice]').parent().removeClass('disabled');
        }
    });

    // addon empty fix
    $(document).on('change', 'input[name^=addon]', function () {
        if ($(this).is(':checked')) {
            $(this).parent().find('input[type="hidden"]').attr('disabled', true);
        } else {
            $(this).parent().find('input[type="hidden"]').removeAttr('disabled');
        }
    });

    $('input[name^=addon]').each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().find('input[type="hidden"]').attr('disabled', true);
        } else {
            $(this).parent().find('input[type="hidden"]').removeAttr('disabled');
        }
    });


    // -----------------------
    // calendar - range slider
    // -----------------------
    var dateSlider = document.getElementById('slider-date');
    // nouislider settings
    if (dateSlider) {
        var months = [
            "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
        ];
        // dates
        var sliderStartDate = $('input[name="start_date"]').val();
        var sliderEndDate = $('input[name="end_date"]').val();

        sliderStartDate = sliderStartDate.split('/');
        sliderEndDate = sliderEndDate.split('/');

        var currentMonth = parseInt(sliderStartDate[0]);
        var currentYear = parseInt(sliderStartDate[1]);

        var endMonth = parseInt(sliderEndDate[0]);
        var endYear = parseInt(sliderEndDate[1]);

        var numOfMonths;
        if (currentYear == endYear) {
            numOfMonths = endMonth - currentMonth;
        } else {
            numOfMonths = endMonth - currentMonth + 12;
        }

        var toEndOfYear = (12 - currentMonth) * 10;
        var nextYear = currentYear + 1;

        // func
        function getMonthName(num) {
            return months[(num - 1) % 12];
        }

        function roundNumber(num) {
            return Math.round(num)
        }
        function numberToYear() {
            return nextYear;
        }

        var pips;
        if (((numOfMonths + 1) * 10) > toEndOfYear) {
            pips = {
                mode: 'positions',
                values: [(toEndOfYear / numOfMonths) * 10],
                format: { to: numberToYear, from: Number },
                density: 100
            }
        }
        noUiSlider.create(dateSlider, {
            behaviour: 'snap',
            tooltips: false,
            connect: true,
            format: {
                to: roundNumber,
                from: Number
            },
            range: {
                min: [currentMonth],
                max: [currentMonth + numOfMonths]
            },
            step: 1,
            start: [currentMonth, currentMonth + numOfMonths],
            pips: pips,
        });

        dateSlider.noUiSlider.on('change', function (values, handle) {
            var value_start;
            var value_end;
            if (values[0] <= 12 && values[1] > 12) {
                value_start = [values[0], currentYear];
                value_end = [values[1] - 12, endYear];
            } else if (values[0] > 12 && values[1] > 12) {
                value_start = [values[0] - 12, endYear];
                value_end = [values[1] - 12, endYear];
            } else {
                value_start = [values[0], currentYear];
                value_end = [values[1], currentYear];
            }

            $('input[name="start_date"]').val(value_start.join('/'));
            $('input[name="end_date"]').val(value_end.join('/')).change();

        });

        dateSlider.noUiSlider.on('update', function (values, handle) {
            var value_start;
            var value_end;
            if (values[0] <= 12 && values[1] > 12) {
                value_start = currentYear;
                value_end = endYear;
            } else if (values[0] > 12 && values[1] > 12) {
                value_start = endYear;
                value_end = endYear;
            } else {
                value_start = currentYear;
                value_end = currentYear;
            }

            $('.noUi-handle[data-handle=0]').html('<div class="noUi-tooltip">' + getMonthName(values[0]) + ' ' + value_start + '</div>');
            $('.noUi-handle[data-handle=1]').html('<div class="noUi-tooltip">' + getMonthName(values[1]) + ' ' + value_end + '</div>');

        });


    }

    // -----------------------
    // calendar - events
    // -----------------------
    function initCalendar() {

        if ($('.calendar-table .calendar-table__event').length > 0) {

            // convert hex colors to rgb
            function hexToRGB(hex, alpha) {
                const r = parseInt(hex.slice(1, 3), 16),
                    g = parseInt(hex.slice(3, 5), 16),
                    b = parseInt(hex.slice(5, 7), 16);

                if (alpha) {
                    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
                } else {
                    return "rgb(" + r + ", " + g + ", " + b + ")";
                }
            }

            // change event colors
            $('input[data-category-color]').each(function (index, item) {
                const color = $(item).data('category-color');
                const category = $(item).val();

                const selector = `.calendar-table__event[data-category="${category}"]`;
                $(selector).css('background-color', color);

                $(selector).find('.calendar-table__event-gradient').css('background-image', `linear-gradient(to right, ${hexToRGB(color, "0")}, ${color})`);
            });

            let timeout = false;

            $(window).on('resize', function (e) {

                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    // assign event widths
                    $('.calendar-table__event[data-fill]').each(function (index, item) {
                        const fill = $(item).data('fill');

                        const viewport = window.matchMedia("(min-width: 576px)");

                        if ($(item).hasClass('multiple')) {
                            if (viewport.matches) {
                                // sm
                                $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - 13px)`);
                            } else {
                                // xs
                                $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - 7px)`);
                            }
                        } else {
                            if (viewport.matches) {
                                // sm
                                $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - (22px))`);
                            } else {
                                // xs
                                $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - (13px))`);
                            }
                        }
                    });

                    $('.calendar-table__event.visible').each(function (index, item) {
                        const category = $(this).data('category');
                        const inputSelector = `input[value="${category}"]`;
                        const eventSelector = `.calendar-table__event[data-category="${category}"]`;

                        const color = $(inputSelector).data('category-color');
                        const height = $(eventSelector).height();

                        $(this).find('.addon').css('background-color', color);
                        $(this).height(height);

                        if ($(this).hasClass('sunday-no-last')) {
                            $(this).find('.addon-2').css('background-color', color);
                        }
                    });

                    // make event texts swipable
                    $('.swiper-container.swiper-text').each(function (item, element) {

                        var swiper = new Swiper($(element), {
                            init: false,
                            slidesPerView: "auto",
                            spaceBetween: 40,
                            touchRatio: 0,
                            speed: 10000,
                            loop: true,
                            loopedSlides: 1,
                            autoplay: {
                                disableOnInteraction: false,
                                delay: 0,
                            },
                        });

                        let box = $(element).parent();
                        let text = $(element).find('.calendar-table__event-name');

                        // let boxWidth = box[0].getBoundingClientRect().width;
                        let boxWidth = box[0].style.width.match(/\(([^)]+)\)/)[1];
                        boxWidth = parseInt(boxWidth, 10);
                        let textWidth = text[0].getBoundingClientRect().width;

                        box.addClass('calendar-table__event--no-gradient');

                        if (boxWidth < textWidth) {

                            box.find('.swiper-slide').css('width', textWidth);
                            box.removeClass('calendar-table__event--no-gradient');
                            swiper.init();

                        }

                    });

                }, 250);

            });

            $('.calendar-table__event[data-fill]').each(function (index, item) {
                const fill = $(item).data('fill');

                const viewport = window.matchMedia("(min-width: 576px)");

                if ($(item).hasClass('multiple')) {
                    if (viewport.matches) {
                        // sm
                        $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - 13px)`);
                    } else {
                        // xs
                        $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - 7px)`);
                    }
                } else {
                    if (viewport.matches) {
                        // sm
                        $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - (22px))`);
                    } else {
                        // xs
                        $(item).css('width', `calc(((${$('.calendar-table').width()}px / 7) * ${fill}) - (13px))`);
                    }
                }
            });

            // swiper - calendar text
            $('.swiper-container.swiper-text').each(function (item, element) {

                var swiper = new Swiper($(element), {
                    init: false,
                    slidesPerView: "auto",
                    spaceBetween: 40,
                    touchRatio: 0,
                    speed: 10000,
                    loop: true,
                    loopedSlides: 1,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 0,
                    },
                });

                let box = $(element).parent();
                let text = $(element).find('.calendar-table__event-name');

                // let boxWidth = box[0].getBoundingClientRect().width;
                let boxWidth = box[0].style.width.match(/\(([^)]+)\)/)[1];
                boxWidth = parseInt(boxWidth, 10);
                let textWidth = text[0].getBoundingClientRect().width;

                box.addClass('calendar-table__event--no-gradient');

                if (boxWidth < textWidth) {

                    box.find('.swiper-slide').css('width', textWidth);
                    $(element).parent().removeClass('calendar-table__event--no-gradient');

                    swiper.init();
                } else {
                    swiper.destroy(false, false);
                }

            });
        }
    }
    initCalendar();

    // -----------------------
    // calendar - filters on mobile
    // -----------------------
    const showFilters = $('#showFilters');
    showFilters.on('click', function (event) {
        event.preventDefault();
        /* Act on the event */
        const filters = $('#calendarFilters');
        const active = filters.hasClass('active');

        if (active) {
            mobileBtn.removeClass('calendarActive');
            mobileNav.removeClass('active');
            $('body,html').removeClass('body-overflow');
        } else {
            filters.addClass('active');
            header.addClass('bgwhite');
            $('.calendar').addClass('active');
            mobileBtn.addClass('calendarActive active');
            mobileNav.removeClass('active');
            $('body,html').scrollTop(0).addClass('body-overflow');
        }
    });

    const closeFiltersBtn = $('.mobile-btn, .calendarCloseFilters');
    closeFiltersBtn.on('click', function (event) {
        const filters = $('#calendarFilters');
        const active = filters.hasClass('active');

        if (active) {
            mobileBtn.removeClass('calendarActive active');
            mobileNav.removeClass('active');
            filters.removeClass('active');
            header.removeClass('bgwhite');
            $('.calendar').removeClass('active');
            // $('.calendar-row').show();
        } else {
        }
    });

    $(window).on('resize', function () {
        var win = $(this);
        const filters = $('#calendarFilters');
        const active = filters.hasClass('active');
        if (win.width() >= 768 && active) {
            mobileBtn.removeClass('calendarActive active');
            mobileNav.removeClass('active');
            filters.removeClass('active');
            header.removeClass('bgwhite');
            $('.calendar').removeClass('active');
        }
    });


    // ------------
    // Calendar - filters
    // ------------
    const calendarSpinner = $('.page-calendar .spinner');
    const calendarContent = $('.page-calendar .calendar__content');
    function reloadCalendar(start, end, categories, locations) {
        $.ajax({
            url: main.ajax_url,
            type: 'post',
            data: {
                action: 'reload_calendar',
                start: start,
                end: end,
                categories: categories,
                locations: locations
            },
            beforeSend: function () {
                calendarSpinner.show();
                calendarContent.hide();
            },
            complete: function () {
                calendarSpinner.hide();
            },
            error: function (error) {
                console.log(error);
            },
            success: function (res) {
                calendarContent.html(res);
                calendarContent.show();
                AOS.refreshHard();
                initCalendar();
            },
        });
    }

    $('.calendar-filter').on('change', 'input[name="category[]"], input[name="location[]"], input[name="start_date"], input[name="end_date"]', function () {
        const selectedCategories = $.map($('input[name="category[]"]:checked'), function (value, index) {
            return $(value).val();
        });
        const selectedLocations = $.map($('input[name="location[]"]:checked'), function (value, index) {
            return $(value).val();
        });
        const startDate = $('input[name="start_date"]').val();
        const endDate = $('input[name="end_date"]').val();

        reloadCalendar(startDate, endDate, selectedCategories, selectedLocations);
    });

    // ------------
    // Calendar - PDF
    // ------------
    $('.generatePDF').on('click', function (e) {
        e.preventDefault();
        $('#calendarFilters').submit();
    });

    // ---------------
    // Clients - popup
    // ---------------
    const clientsWrapper = $('#clientsPopup');

    function showPopup(el) {
        el.show();
        clientsWrapper.addClass('active');
        $('body').addClass('body-overflow');
    }
    function hidePopup(el) {
        el.hide();
        clientsWrapper.removeClass('active');
        $('body').removeClass('body-overflow');
    }
    clientsWrapper.on('click', function (event) {
        event.preventDefault();
        $(this).removeClass('active');
        $(this).find('.module-popup').hide();
        $('body').removeClass('body-overflow');
    });
    $('.module-popup').on('click', function (e) {
        e.stopPropagation();
    });
    $('.module-popup__close').on('click', function () {
        const popup = $(this).parent();
        hidePopup(popup);
        return false;
    });
    $('.module-clients').on('click', '.module-clients__box', function () {
        const popupId = $(this).data('id');
        const selector = '.module-popup[data-id="' + popupId + '"]';
        const popup = $(selector);

        if (popup.length > 0) {
            showPopup(popup);

            // swiper clients popup
            const clientsPopup = $(selector).find('.swiper-container');
            if (clientsPopup.length > 0) {

                clientsPopup.each(function (index, element) {

                    let swiper = new Swiper(element, {
                        allowTouchMove: false,
                        slidesPerView: 1,
                        threshold: 20,
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'bullets',
                            clickable: true,
                        },
                        breakpoints: {
                            991: {
                                allowTouchMove: true,
                            }
                        }
                    });
                });
            }

        }
        return false;
    });

    // module partners swiper
    const partnersModule = $('.module-partners .swiper-container');
    if (partnersModule.length > 0) {

        partnersModule.each(function (index, element) {

            let swiper = new Swiper(element, {
                allowTouchMove: false,
                slidesPerView: 1,
                threshold: 20,
                pagination: {
                    el: '.module-partners .swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    991: {
                        allowTouchMove: true,
                    }
                }
            });
        });

    }

    // ------------
    // Clients - ajax
    // ------------
    const moreClientsBtn = $('#moreClients');
    const clientContainer = $('#clientsContainer');
    const clientsSpinner = $('.module-clients .spinner');
    let clientsPage = 1;
    const clientsPerPage = 10;
    moreClientsBtn.on('click', function (e) {
        e.preventDefault();
        const offset = $(this).data('offset') || 0;
        const total = $(this).data('total') || 0;
        const categories = $.map($('input[name="clientsCategory[]"]:checked'), function (value, index) {
            return $(value).val();
        });

        $.ajax({
            url: main.ajax_url,
            type: 'post',
            data: {
                action: 'more_clients',
                page: clientsPage,
                offset: offset,
                per_page: clientsPerPage,
                categories: categories
            },
            beforeSend: function () {
                clientsSpinner.show();
                moreClientsBtn.hide();
            },
            complete: function () {
                clientsSpinner.hide();
            },
            error: function (error) {
                console.log(error);
            },
            success: function (res) {
                clientsPage++;
                clientContainer.append(res);

                if (total > (offset + clientsPage * clientsPerPage)) {
                    moreClientsBtn.show();
                }
            },
        });
    });

    // ------------
    // Clients - filters
    // ------------
    function reloadClients(per_page, categories) {
        clientsPage = 0;
        $.ajax({
            url: main.ajax_url,
            type: 'post',
            data: {
                action: 'reload_clients',
                per_page: per_page,
                offset: 0,
                page: 0,
                categories: categories
            },
            beforeSend: function () {
                clientsSpinner.show();
                clientContainer.hide();
                moreClientsBtn.hide();
            },
            complete: function () {
                clientsSpinner.hide();
            },
            error: function (error) {
                console.log(error);
            },
            success: function (res) {
                const parts = res.split(";separator;", 2);
                clientContainer.html(parts[1]);
                clientContainer.show();
                AOS.refreshHard();

                const total = parts[0];
                moreClientsBtn.data('total', parseInt(total));

                if (total >= per_page) {
                    moreClientsBtn.show();
                }
            },
        });
    }
    $('.module-clients__form').on('change', 'input[name="clientsCategory[]"]', function () {
        const categories = $.map($('input[name="clientsCategory[]"]:checked'), function (value, index) {
            return $(value).val();
        });
        const perPage = $('#clientsContainer').data('perpage');

        reloadClients(perPage, categories);
    });

    // ------------
    // Clients - PDF
    // ------------
    $('.generateClientsPDF').on('click', function (e) {
        e.preventDefault();
        $('#clientsFilters').submit();
    });

    // scroll to serach resoult

    const search = $('input[name="s"]');
    if (search.length > 0 && search.val() !== '') {
        $('html, body').animate({ scrollTop: search.offset().top - 100 }, 1000);
    }

    // orphans
    // $('p, h1, h2, h3, h4, h5, h6, h7, h8, ol, ul')
    // $('.orphans').each(function() {
    //     var $html = $(this).text();
    //     $html = $html.replace(/(\s)([\S])[\s]+/g,"$1$2&nbsp;");
    //     $html = $html.replace(/(\s)([^<][\S]{1})[\s]+/g,"$1$2&nbsp;");
    //     $html = $html.replace(/(\s)([^<][\S]{2})[\s]+/g,"$1$2&nbsp;");
    //     $(this).empty().text($html);
    // });

    $('h1, h2, h3, h4, h5, h6, p, ol, ul').each(function () {
        var text = $(this).html();
        text = text.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;"); //jednoznakowe
        text = text.replace(/(\s)([^<][\S]{1})[\s]+/g, "$1$2&nbsp;"); //dwuznakowe
        $(this).html(text);
    });


    // cookies
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    if (getCookie('cookies_msg') != 1) {
        $('.module-cookies').show();
    }
    $('.module-cookies__btn').on('click', function (e) {
        e.preventDefault();
        $('.module-cookies').slideUp();
        setCookie('cookies_msg', 1, 30);
        return false;
    });

    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom: 14,
            disableDefaultUI: true,
            scrollwheel: false,
            zoomControl: true,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
              },
            styles: [{featureType:"water",elementType:"geometry",stylers:[{color:"#e9e9e9"},{lightness:17}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:20}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21}]},{elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]}]
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    var icon = {
        path: "M23,0C11.7,0,0,8.6,0,23.1C0,37,21.4,58.8,22.3,59.7c0.4,0.4,1,0.4,1.4,0c0,0,0,0,0,0C24.6,58.8,46,37,46,23.1 C46,8.6,34.3,0,23,0z M23,30c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S26.9,30,23,30z",
        fillColor: '#282828',
        fillOpacity: 1,
        animation: google.maps.Animation.DROP,
        anchor: new google.maps.Point(20, 60),
        strokeWeight: 0,
        scale: 0.7
      };

    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            animation: google.maps.Animation.DROP,
            icon: icon,
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map__inner').each(function(){
        var map = initMap( $(this) );
    });
});
}); // jQuery - END


function recaptcha_callback() {
    jQuery('button').removeAttr('disabled');
};
